import apiService from '@/services/apiService';

const actions = {
  getInternalUsers({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('user')
        .then((response) => {
          commit('getInternalUsers', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getInternalUsersPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('user/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getInternalUser({ commit }, payload) {
    apiService.get(`user/${payload}`)
      .then((response) => {
        commit('getInternalUser', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getInternalUserHeader({ commit }, payload) {
    apiService.get(`user/${payload}`)
      .then((response) => {
        commit('getInternalUserHeader', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getRole({ commit }) {
    apiService.get('user/get-user-roles')
      .then((response) => {
        commit('getRole', response.data.data);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  changeStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`user/${payload.id}/${payload.change}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postInternalUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('user/register', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  putChangePassword({ commit }, payload) {
    apiService.post('user/change-password', payload.formData)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  putChangePasswordOther({ commit }, payload) {
    apiService.post('user/change-password-other-user', payload.formData)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  putInternalUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`user/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delInternalUser({ commit }, payload) {
    apiService.delete(`user/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  },
};

export default actions;
